import { createFileRoute } from '@tanstack/react-router';
import { LegalDoc } from '../components/legal/LegalDoc';
import content from '../content/legal/refund-policy.md?raw';

export const Route = createFileRoute('/refund')({
  component: () => <LegalDoc content={content} />,
});
